import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Terminal, Line } from '../interface'

import { Line as LineComponent } from './Line'
import { Terminal as TerminalComponent } from './Terminal'

const useStyle = makeStyles({
    root: {
        position: 'relative',
        width: '95%',
        height: '95%',
        backgroundColor: '#e0e0e0'
    }
})

interface CellProps {
    terminal?: Terminal
    lineSources: Line[]
    lineDestinations: Line[]
}

const swapLineSourceDestination = (line: Line): Line => {
    let tmp = line.source
    line.source = line.destination
    line.destination = tmp
    return line
}

export const Cell = React.memo((props: CellProps): JSX.Element => {
    const { terminal, lineSources, lineDestinations } = props
    const classes = useStyle()

    let lineSource: Line | undefined
    let lineDestination: Line | undefined

    if (lineSources.length === 1) {
        lineSource = lineSources[0]
    }
    if (lineDestinations.length === 1) {
        lineDestination = lineDestinations[0]
    }
    if (lineSources.length === 0 && lineDestinations.length === 2) {
        lineDestination = lineDestinations[0]
        lineSource = swapLineSourceDestination({ ...lineDestinations[1] })
    }
    if (lineSources.length === 2 && lineDestinations.length === 0) {
        lineSource = lineSources[0]
        lineDestination = swapLineSourceDestination({ ...lineSources[1] })
    }

    return <div className={classes.root}>
        {terminal && <TerminalComponent color={terminal.color} />}
        {lineSource && <LineComponent color={lineSource.color}
            rowDifference={lineSource.source.row - lineSource.destination.row}
            columnDifference={lineSource.source.column - lineSource.destination.column} />}
        {lineDestination && <LineComponent color={lineDestination.color}
            rowDifference={lineDestination.destination.row - lineDestination.source.row}
            columnDifference={lineDestination.destination.column - lineDestination.source.column} />}
    </div>
}, (prevProps: CellProps, nextProps: CellProps) => {
    if (prevProps.terminal !== nextProps.terminal) return false
    if (prevProps.lineSources[0] !== nextProps.lineSources[0]) return false
    if (prevProps.lineSources[1] !== nextProps.lineSources[1]) return false
    if (prevProps.lineDestinations[0] !== nextProps.lineDestinations[0]) return false
    if (prevProps.lineDestinations[1] !== nextProps.lineDestinations[1]) return false
    return true
})
